import $ from "jquery";
import bdjs from "@bd-core/bdjs";

export const LoginPage = () => {
    const isLoginPage = $("#login-page").length > 0;
    if(!isLoginPage) return false;

    bdjs.hideLoading();

    const onGoToSSO = function () {
        const $this = $(this);

        window.location.href = $this.attr("data-url");
        return false;
    };

    $(".js-login-btn").on("click", onGoToSSO);

    const $snackBar = $(".snackbar");

    // Snackbar Component
    // ------------------------------------------------------------------------
    $snackBar.find(".snackbar__close").on("click", function (e) {
        e.preventDefault();
        $snackBar.removeClass("is-active");
    });
}